import * as type from './types';

export function markProjectCompleted(data) {
    return {
        type: type.POST_PROJECT_COMPLETED_REQUESTED,
        data: data,
    }
}